export const TEST_TIME = 1
export const GRID_SIZE = 7
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBcNzzrU5IyX8C8LSe3D6_BFrBh-kD9nn8',
  authDomain: 'grid-test-alpha.firebaseapp.com',
  databaseURL: 'https://grid-test-alpha.firebaseio.com',
  projectId: 'grid-test-alpha',
  storageBucket: 'grid-test-alpha.appspot.com',
  messagingSenderId: '959362094504'
}
